exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".c-logo {\n  width: 100%;\n  line-height: 1; }\n  .c-logo svg {\n    width: 100%; }\n", "", {"version":3,"sources":["/tmp/build_3f9f81bc/src/components/Logo/src/components/Logo/Logo.scss"],"names":[],"mappings":"AACA;EACI,YAAW;EACX,eAAc,EAKjB;EAPD;IAKQ,YAAW,EACd","file":"Logo.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.c-logo {\n    width: 100%;\n    line-height: 1;\n\n    svg {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"variables/"; @import /"mixins/";","includePaths":["/tmp/build_3f9f81bc/src/scss"]}!./src/components/Logo/Logo.scss
// module id = 516
// module chunks = 0